import { first } from 'rxjs/operators';

export class User {
    constructor(
        firstName: string,
        lastName: string,
        authorities: string[],
        cfaGuid: string,
    ) 
    {
        this.firstName = firstName;
        this.lastName = lastName;
        this.authorities = authorities;
        this.cfaGuid = cfaGuid;
    }
    public firstName: string;
    public lastName: string;
    public authorities: string[];
    public cfaGuid: string
}